import styled, { css } from 'styled-components'
import tw from 'twin.macro'

export const ErrorViewContainer = styled.div`
  ${tw`w-screen h-screen flex flex-col items-center justify-center bg-catskillWhite1`}
`

export const ErrorMessage = styled.span`
  font-family: 'Inter';
  ${tw`not-italic	font-normal	text-lg	leading-5 text-center	text-darkLightBlueGray mt-4`}
`
